<template>
<div>
    <vue-pdf-embed :source="`document/`+pdf_source" 
    />
</div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
    components: {
        VuePdfEmbed,
    },
    data() {
        return {
            
        }
    },
    props:{
        pdf_source: { type: String }
    },
    computed:{

    },
    methods:{

    }

}
</script>

<style>

</style>